export default __webpack_public_path__ + "static/media/hero.86c71aac.jpg";